import { render, staticRenderFns } from "./Rider.vue?vue&type=template&id=222b242e&scoped=true"
import script from "./Rider.vue?vue&type=script&lang=js"
export * from "./Rider.vue?vue&type=script&lang=js"
import style0 from "./Rider.vue?vue&type=style&index=0&id=222b242e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b242e",
  null
  
)

export default component.exports